import BoxSVG from "@assets/images/box-export.svg";
import DatepickerIcon from "@assets/images/date-picker.svg";
import externalLinkIcon from "@assets/images/external-link.svg";
import TrashCan from "@assets/images/trash.svg";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import ModalInputParameter from "@saleor/changeOrderExport/components/ModalInputParameter/ModalInputParameter";
import { formatConditionGroup } from "@saleor/changeOrderExport/utils";
import Checkbox from "@saleor/components/Checkbox";
import DatePicker from "@saleor/components/DatePicker";
import DatePickerApplyAll from "@saleor/components/DatePickerApplyAll";
import DecimalFormat from "@saleor/components/DecimalFormat";
import DialogConfirmDelete from "@saleor/components/DialogConfirmDelete";
import DialogProcessing from "@saleor/components/DialogProcessing";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat/NumberFormat";
import PopoverApplyAll from "@saleor/components/PopoverApplyAll";
import SearchRoute from "@saleor/components/SearchRoute";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import { SingleTextField } from "@saleor/components/SingleTextField";
import SingleTextFieldNoBlock from "@saleor/components/SingleTextField2";
import Skeleton from "@saleor/components/Skeleton";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { TablePaginationCustom } from "@saleor/components/TablePaginationCustom";
import TextAreaField from "@saleor/components/TextAreaField";
import { REGEX_ONLY_NUMBER, REGEX_ONLY_NUMBER_CHARACTER } from "@saleor/config";
import FullScreenButton from "@saleor/createOrderExport/components/FullScreenButton";
import { MAX_LENGTH_REF_PI } from "@saleor/createOrderExport/components/MaterialItemTab/const";
import { ExportOrderSortField } from "@saleor/createOrderExport/urls";
import EmptyProduct from "@saleor/createOrderExport/views/CartDetailExport/EmptyProduct";
import {
  checkTotalQuantity,
  createPackingList
} from "@saleor/createOrderExport/views/CreateOrderView/utils";
import {
  ExportOrderWithAllItemsQuery,
  useDeleteExportOrderLinesMutation,
  usePassParameterToIPlanMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import { renderCollection } from "@saleor/misc";
import { ListProps, RelayToFlatNoEdge, SortPage } from "@saleor/types";
import {
  calculateNewPackage,
  calculateNewPalletNo,
  calculateNewTotalWeight
} from "@saleor/utils/number";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import { getFormik } from "./formik";
import useStyles from "./styles";

interface MaterialItemTabProps
  extends ListProps,
    SortPage<ExportOrderSortField> {
  data: RelayToFlatNoEdge<
    ExportOrderWithAllItemsQuery["exportOrderWithAllItems"]
  >;
  reFetchExportOrder: () => void;
  latestPageItemNumber: number | null;
  currency: string;
  onPreviousFirstPage: () => void;
  onNextLastPage: () => void;
  totalCount?: number;
  saveDraftCall?: number;
  submitOrderCall?: number;
  currentTab?: string;
  listMaterialCurrent: any[];
  setListMaterial: (value) => void;
  listMaterial: any[];
  isSelected: (data) => boolean;
  listElements: any[];
  reset: () => void;
  toggle: (data) => void;
  set: (value) => void;
  isErrorQuantity: (data) => boolean;
  setCollectDataSubmit?: (value) => void;
  listMaterialAll?: any[];
}

const totalCols = 20;

const MaterialItemTab: React.FC<MaterialItemTabProps> = props => {
  const {
    data,
    settings,
    onUpdateListSettings,
    onNextPage,
    onPreviousPage,
    pageInfo,
    disabled,
    onSort,
    sort,
    onNextLastPage,
    latestPageItemNumber,
    onPreviousFirstPage,
    totalCount,
    submitOrderCall,
    saveDraftCall,
    listMaterial,
    setListMaterial,
    listMaterialCurrent,
    isSelected,
    listElements,
    reset,
    toggle,
    set,
    currentTab,
    isErrorQuantity,
    setCollectDataSubmit,
    currency,
    listMaterialAll
  } = props;
  const intl = useIntl();
  const classes = useStyles();
  const [{ fullScreen }, dispatchAppState] = useAppState();

  const formik = getFormik(listMaterialCurrent);
  const [reRender, setReRender] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [tab, setTab] = useState<number>(0);
  const [openPlant, setOpenPlant] = useState<boolean>(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [resetApplyPlant, setResetApplyPlant] = useState<boolean>(false);
  const [resetApplyDate, setResetApplyDate] = useState<boolean>(false);
  const [componentKey, setComponentKey] = useState<number>(0);
  const [isOpenModalInputParameter, setIsOpenModalInputParameter] = useState<
    boolean
  >(false);
  const [orderLine, setOrderLine] = useState(null);
  useEffect(() => {
    if (formik) {
      formik.validateForm();
    }
  }, []);

  useEffect(() => {
    dispatchAppState({
      payload: {
        tabMaterial: tab
      },
      type: "setTabMaterial"
    });
  }, [tab]);

  useEffect(() => {
    setReRender(prevState => !prevState);
  }, [fullScreen]);

  useEffect(() => {
    setReRender(prevState => !prevState);
    if (containerRef.current) {
      containerRef!.current!.scrollLeft = 0;
    }
  }, [tab]);

  const [
    deleteExportOrderLines,
    { loading: loadingDelivery }
  ] = useDeleteExportOrderLinesMutation({
    onCompleted: data => {
      const errors = data?.deleteExportOrderLines?.errors;
      if (errors.length === 0) {
        const length = formik.values.requestDate.length - listElements.length;
        let countDesc = 10 * (length + 1);
        let countAsc = 0;
        const isDescItemNo =
          sort.sort === ExportOrderSortField.item_no && !sort.asc;
        const newListMaterial = listMaterialAll
          .filter(line => !listElements.includes(line.id))
          .map(item => ({
            ...item,
            itemNo: isDescItemNo ? (countDesc -= 10) : (countAsc += 10)
          }));
        setListMaterial(newListMaterial);
        onPreviousFirstPage();
        reset();
      }
    }
  });

  const handleOnApplyAllPlant = value => {
    setResetApplyPlant(prevState => !prevState);
    formik.setFieldValue(
      "plant",
      formik.values.plant.map((_, idx) => {
        if (!isContainer(listMaterialCurrent[idx])) {
          return value;
        }
        return null;
      })
    );
    setListMaterial(oldData =>
      oldData.map(item => ({
        ...item,
        plant: isContainer(item) ? item.plant : value
      }))
    );
    setOpenPlant(false);
  };

  const handleApplyAllRequestDate = value => {
    setResetApplyDate(prevState => !prevState);
    formik.setFieldValue(
      "requestDate",
      formik.values.requestDate.map(() => value)
    );
    setListMaterial(oldData =>
      oldData.map(item => ({
        ...item,
        requestDate: value
      }))
    );
  };

  const handleInputParam = order => {
    setComponentKey(prev => prev + 1);
    setIsOpenModalInputParameter(true);
    setOrderLine(order);
  };

  const handleCloseModalInputParameter = () => {
    setIsOpenModalInputParameter(false);
  };

  const [passParameter] = usePassParameterToIPlanMutation();
  const handleSaveInputParameter = choice => {
    setListMaterial(prev =>
      prev.map(item => {
        if (item.itemNo === orderLine.itemNo) {
          return {
            ...item,
            inquiryMethod: choice
          };
        }
        return item;
      })
    );
    passParameter({
      variables: {
        orderLineId: orderLine.id,
        inquiryMethodCode: choice
      }
    }).then(result => {
      if (result?.data?.passParameterToIPlan?.status) {
        setOrderLine(null);
      }
    });
    setIsOpenModalInputParameter(false);
  };

  const renderTabTable = () => (
    <div className={classes.tabBox}>
      <div
        className={classNames(
          classes.boxShadowTab,
          tab === 0 ? classes.z1 : classes.z0
        )}
      >
        <Button
          id="sales-condition-tab"
          data-testid="sales-condition-tab"
          onClick={() => setTab(0)}
          className={classNames(
            classes.tableTab,
            tab === 0 ? classes.active : classes.notActive
          )}
        >
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage: "Sales Condition"
            })}
          </MyTypography>
        </Button>
      </div>
      <div
        className={classNames(
          classes.boxShadowTab,
          tab === 1 ? classes.z1 : classes.z0
        )}
      >
        <Button
          id="order-details-tab"
          data-testid="order-details-tab"
          onClick={() => setTab(1)}
          className={classNames(
            classes.tableTab,
            classes.tabB,
            tab === 1 ? classes.active : classes.notActive
          )}
        >
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage: "Order Details"
            })}
          </MyTypography>
        </Button>
      </div>
    </div>
  );

  const renderTabA = () => (
    <>
      <TableCellHeader
        width={120}
        style={{ minWidth: "120px", borderRight: 0 }}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "จำนวน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={72} style={{ minWidth: "72px" }}>
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={80}
        className={classes.noBorderRight}
        textAlign={"right"}
        style={{ minWidth: "80px" }}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "น้ำหนัก" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={128} style={{ minWidth: "128px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Cat (EO)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคา/หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={88} style={{ minWidth: "88px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Currency" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        className={classes.tableCellCenter}
        style={{ minWidth: "128px" }}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Plant" })}
        </MyTypography>
        <Button
          ref={anchorRef}
          className={classNames(
            classes.buttonApply,
            openPlant && classes.btnApplyOpen
          )}
          variant="contained"
          onClick={() => setOpenPlant(true)}
          name="apply-all-button"
          id="apply-all-button"
        >
          {openPlant && (
            <SVG src={DatepickerIcon} className={classes.svgDatePicker} />
          )}
          Apply all
        </Button>
        <PopoverApplyAll
          anchorEl={anchorRef.current}
          onClose={() => setOpenPlant(false)}
          open={openPlant}
          onOk={handleOnApplyAllPlant}
          title={"Plant"}
          maxLengthInput={4}
        />
      </TableCellHeader>
      <TableCellHeader
        width={200}
        style={{ minWidth: "210px" }}
        className={`${classes.borderRight} ${classes.tableCellCenter}`}
      >
        <MyTypography variant={"subtitle3"}>
          <div>{intl.formatMessage({ defaultMessage: "Request Date" })}</div>
          <DatePickerApplyAll onApplyAll={handleApplyAllRequestDate} />
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={128} style={{ minWidth: "128px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ref. PI Stock" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={200}
        style={{ minWidth: "100px" }}
        className={`${classes.borderRight} ${classes.tableCellCenter}`}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "( P )" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );

  const renderTabB = () => (
    <>
      <TableCellHeader width={320} style={{ minWidth: "480px" }} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Route" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={"160px"}
        style={{ minWidth: "160px" }}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Condition Group 1" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={160} style={{ minWidth: "160px" }} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Material Group 2" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        textAlign={"center"}
        style={{ minWidth: "112px" }}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} align={"center"}>
          {intl.formatMessage({ defaultMessage: "Commission (%)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} align={"center"}>
          {intl.formatMessage({ defaultMessage: "Commission amount" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} align={"center"}>
          {intl.formatMessage({ defaultMessage: "Com. Unit" })}
        </MyTypography>
      </TableCellHeader>
      {haveNormalProduct ? (
        <TableCellHeader
          width={280}
          style={{ minWidth: "280px" }}
          textAlign={"center"}
          className={classes.customCell}
          colSpan={3}
        >
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({ defaultMessage: "Delivery Tolerance" })}
          </MyTypography>
        </TableCellHeader>
      ) : (
        ""
      )}
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Roll Diameter" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Roll Core Diameter" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "No. of Rolls" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ream/Roll per Pallet" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Pallet Size" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Pallet No." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "No. of Package" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={440}
        style={{ minWidth: "440px" }}
        textAlign={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Packing List" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={200}
        style={{ minWidth: "200px" }}
        textAlign={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Shipping Point" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={440}
        style={{ minWidth: "440px" }}
        textAlign={"center"}
        rowSpan={haveNormalProduct ? 2 : 1}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Remark" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );

  const handleClickCheckBox = (e, id: string, field: string, index) => {
    const check = e.target.checked;
    formik
      .setFieldValue(`deliveryTolOver[${index}]`, check ? 0 : "", true)
      .then(() => formik.validateForm());
    formik
      .setFieldValue(`deliveryTolUnder[${index}]`, check ? 0 : "", true)
      .then(() => formik.validateForm());
    handleChangeInput(e, id, field, check);
  };

  const handleChangeRoute = (route, itemId) => {
    const indexOfItem = listMaterial.findIndex(item => item.id === itemId);
    const value = {
      target: {
        value: route,
        name: `route[${indexOfItem}]`
      }
    };
    handleChangeInput(value, itemId, "route");
  };

  const handleChangeInput = (event, id: string, field: string, extraValue?) => {
    formik.setFieldValue(
      event.target.name,
      extraValue || event.target.value,
      true
    );

    const newState = listMaterial.map(obj => {
      if (obj.id === id) {
        if (field === "quantity") {
          const value = parseInt(event.target.value, 10) || 0;
          obj.weight = calculateNewTotalWeight(value, obj);
          const reamRollPerPallet = obj.rollPerPallet || 0;
          obj.packageQuantity = calculateNewPackage(value, reamRollPerPallet);
        }
        if (field === "rollPerPallet") {
          const value = parseInt(event.target.value, 10) || 0;
          obj.packageQuantity = calculateNewPackage(obj.quantity, value);
        }
        if (field === "weightUnit") {
          const previousLine = obj;
          const newUnit = event.target.value;

          if (
            previousLine.weightUnit === "ตัน" ||
            previousLine.weightUnit === "TON"
          ) {
            if (newUnit !== "ตัน" && newUnit !== "TON") {
              obj.weight = parseFloat(obj.weight) * 1000;
            }
          } else if (previousLine.weightUnit === "Kg.") {
            if (newUnit !== "Kg.") {
              obj.weight = parseFloat(obj.weight) / 1000;
            }
          }
        }

        return { ...obj, [field]: extraValue || event.target.value };
      }
      return obj;
    });
    if (field === "quantity" || field === "rollPerPallet") {
      const newList = [...newState];
      newList.forEach((item, index) => {
        item.palletNo = calculateNewPalletNo(newList, index);
        item.packingList = createPackingList(item);
      });
      if (field === "quantity") {
        const lineChange = newList.find(item => item.id === id);
        const productChange = lineChange?.piProduct?.id;
        const allLineProduct = newList.filter(
          item => item?.piProduct?.id === productChange
        );
        const isExceed = checkTotalQuantity(newList, lineChange);
        lineChange.errorQuantity = isExceed || !lineChange.quantity;
        if (!isExceed) {
          allLineProduct.forEach(item => (item.errorQuantity = false));
        }
      }
      setListMaterial(newList);
    } else {
      setListMaterial(newState);
    }
  };

  const handleCheckboxAllDelivery = () => {
    if (
      listMaterial.filter(line => line.deliveryTolUnlimited).length ===
      listMaterial.length
    ) {
      updateCheckboxAll(false);
    } else {
      updateCheckboxAll(true);
    }
  };

  const updateCheckboxAll = value => {
    const newState = listMaterial.map(obj => ({
      ...obj,
      deliveryTolUnlimited: value
    }));
    formik
      .setFieldValue(
        "deliveryTolOver",
        formik.values.deliveryTolOver.map(() => (value ? 0 : "")),
        true
      )
      .then(() => formik.validateForm());
    formik
      .setFieldValue(
        "deliveryTolUnder",
        formik.values.deliveryTolUnder.map(() => (value ? 0 : "")),
        true
      )
      .then(() => formik.validateForm());
    setListMaterial(newState);
  };

  const handleCheckboxAll = () => {
    if (listElements.length === listMaterial.length) {
      reset();
      return;
    }

    set(listMaterial.map(item => item.id));
  };

  const handleOpenDelete = () => {
    setOpenDelete(true);
  };

  const deleteOrderLines = () => {
    deleteExportOrderLines({
      variables: {
        deleteAll: false,
        ids: listElements,
        orderId: data.id
      }
    });
    setOpenDelete(false);
  };

  const checkErrorByField = (field: string, index) =>
    !!(formik.errors[field] && formik.errors[field][index]);

  const getErrorTextQuantity = (field: string, index, id) =>
    (formik.errors[field] && formik.errors[field][index]) ||
    (isErrorQuantity(id) &&
      intl.formatMessage({
        defaultMessage: "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"
      })) ||
    "";

  useEffect(() => {
    if (submitOrderCall) {
      const listMaterialError = listMaterial.filter(item => item.errorQuantity);
      if (formik.isValid && !listMaterialError.length) {
        setCollectDataSubmit(true);
      } else {
        setCollectDataSubmit(false);
      }
    }
  }, [submitOrderCall]);

  useEffect(() => {
    if (saveDraftCall) {
      setCollectDataSubmit(true);
    }
  }, [saveDraftCall]);

  const isContainer = item =>
    item?.piProduct?.product?.materialGroup === "PK00";

  const isK01K09 = item =>
    item.materialGroup2?.includes("K01") ||
    item.materialGroup2?.includes("K09");

  const haveNormalProduct = !listMaterial.every(
    item => isContainer(item) || isK01K09(item)
  );

  const isSpecialPlant = item => item.isMaterialOutsource;

  return (
    <>
      <div hidden={fullScreen}>
        <MyTypography variant="subtitle1" className={classes.header}>
          <SVG width={24} height={24} className={classes.svg} src={BoxSVG} />
          {intl.formatMessage({ defaultMessage: "รายละเอียดสินค้า" })}
        </MyTypography>
      </div>
      <DialogConfirmDelete
        onConfirm={deleteOrderLines}
        onCancel={() => setOpenDelete(false)}
        open={openDelete}
        title={"ลบรายการสินค้าที่เลือก"}
        content={
          <MyTypography variant={"body2"}>
            {intl.formatMessage({ defaultMessage: "คุณกำลังจะลบสินค้า" })}
            &nbsp;
            <span className={classes.textQuantityPopup}>
              {listElements.length}
            </span>
            &nbsp;
            {intl.formatMessage({ defaultMessage: "รายการ ในคำสั่งซื้อนี้" })}
          </MyTypography>
        }
      />
      {listMaterialCurrent?.length ? (
        <>
          <div className={classes.topBox}>
            <div className={classes.deleteBox} />
            <FullScreenButton />
          </div>
          <div
            className={classes.tableRoot}
            style={{ overflowX: "auto" }}
            ref={containerRef}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.freezeCell}
                    style={{ border: 0, background: "#f4f7fe", paddingLeft: 0 }}
                    colSpan={4}
                  >
                    <div className={classes.deleteBox}>
                      <MyTypography
                        variant={"body3"}
                        className={classNames(
                          listElements.length === 0 && classes.nonDeleteTxt
                        )}
                      >
                        {intl.formatMessage({ defaultMessage: "เลือกลบ" })}
                        &nbsp;<b>{listElements.length}</b>&nbsp;
                        {intl.formatMessage({ defaultMessage: "รายการ" })}
                      </MyTypography>
                      {listElements.length > 0 && (
                        <SVG
                          className={classes.ml10}
                          src={TrashCan}
                          cursor="pointer"
                          data-testid="open-delete-button"
                          onClick={handleOpenDelete}
                        />
                      )}
                    </div>
                  </TableCell>
                  <TableCell className={classes.freezeCell4}>
                    {renderTabTable()}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCellHeader
                    rowSpan={haveNormalProduct ? 2 : 1}
                    align={"center"}
                    className={classNames(
                      classes.cellCheckBox,
                      classes.tableHeader,
                      classes.freezeCell,
                      classes.borderLeft
                    )}
                  >
                    <div className={classes.boxCheckBox}>
                      <span className={classes.delete}>Delete</span>
                      <Checkbox
                        className={classes.checkBox}
                        size={"small"}
                        checked={listElements.length === listMaterial.length}
                        indeterminate={
                          listElements.length > 0 &&
                          listElements.length < listMaterial.length
                        }
                        onClick={() => handleCheckboxAll()}
                        name="checkbox-header-all"
                        id="checkbox-header-all"
                        data-testid="checkbox-header-all"
                      />
                    </div>
                  </TableCellHeader>
                  <TableCellHeader
                    rowSpan={haveNormalProduct ? 2 : 1}
                    className={classes.freezeCell1}
                    style={{ width: "90px", minWidth: "90px" }}
                    direction={
                      sort.sort === ExportOrderSortField.item_no
                        ? getArrowDirection(sort.asc)
                        : undefined
                    }
                    arrowPosition="right"
                    data-testid="sort-item-no-button"
                    onClick={() => onSort(ExportOrderSortField.item_no)}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Item No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.freezeCell2}
                    style={{ width: "160px", minWidth: "160px" }}
                    rowSpan={haveNormalProduct ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Mat. Code" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.freezeCell3}
                    style={{ width: "320px", minWidth: "320px" }}
                    rowSpan={haveNormalProduct ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({
                        defaultMessage: "Mat. Description"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  {tab === 0 ? renderTabA() : renderTabB()}
                </TableRow>
                {tab === 1 && haveNormalProduct ? (
                  <TableRow>
                    <TableCellHeader
                      width={93}
                      style={{ minWidth: "93px" }}
                      className={classNames(
                        classes.customCell,
                        classes.noBorderRight,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>Under (%)</span>
                    </TableCellHeader>
                    <TableCellHeader
                      width={93}
                      style={{ minWidth: "93px" }}
                      className={classNames(
                        classes.customCell,
                        classes.noBorderRight,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>Over (%)</span>
                    </TableCellHeader>
                    <TableCellHeader
                      width={100}
                      style={{ minWidth: "100" }}
                      className={classNames(
                        classes.borderRight,
                        classes.customCell,
                        classes.unlimited,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>
                        <Checkbox
                          disabled={loadingDelivery}
                          className={classes.checkBox}
                          size={"small"}
                          checked={
                            listMaterial.filter(
                              line => line.deliveryTolUnlimited
                            ).length === listMaterial.length
                          }
                          indeterminate={
                            listMaterial.filter(
                              line => line.deliveryTolUnlimited
                            ).length > 0 &&
                            listMaterial.filter(
                              line => line.deliveryTolUnlimited
                            ).length < listMaterial.length
                          }
                          onClick={() => handleCheckboxAllDelivery()}
                          name="checkbox-header-delivery"
                          id="checkbox-header-delivery"
                        />
                        Unlimited
                      </span>
                    </TableCellHeader>
                  </TableRow>
                ) : (
                  ""
                )}
              </TableHead>
              <TableBody>
                {(listMaterialCurrent && listMaterialCurrent.length) > 0 ? (
                  renderCollection(listMaterialCurrent, (line, index) => (
                    <TableRow key={line.id}>
                      <TableCell
                        className={classNames(
                          classes.borderLeft,
                          classes.freezeCell
                        )}
                      >
                        <Checkbox
                          className={classes.checkBox}
                          size={"small"}
                          checked={isSelected(line.id)}
                          onClick={() => toggle(line.id)}
                          id={`checkbox-${line.id}`}
                        />
                      </TableCell>
                      <TableCell className={classes.freezeCell1}>
                        <MyTypography variant={"body3"}>
                          {line.itemNo}
                        </MyTypography>
                      </TableCell>
                      <TableCell className={classes.freezeCell2}>
                        <MyTypography variant={"body3"}>
                          {line.materialCode}
                        </MyTypography>
                      </TableCell>
                      <TableCell className={classes.freezeCell3}>
                        <MyTypography variant={"body3"}>
                          {line.materialDescription}
                        </MyTypography>
                      </TableCell>

                      {tab === 0 ? (
                        <>
                          <TableCell
                            colSpan={2}
                            style={{ minWidth: "184px" }}
                            width={184}
                          >
                            <div className={classes.boxQuantity}>
                              <MyTypography variant={"body3"}>
                                <NumberFormat
                                  customClass={classes.numberInput}
                                  name={`quantity[${index}]`}
                                  id={`quantity-${line.id}`}
                                  onChange={e =>
                                    handleChangeInput(e, line.id, "quantity")
                                  }
                                  allowLeadingZeros
                                  decimalScale={0}
                                  placeholder={"ระบุจำนวน"}
                                  value={line.quantity || ""}
                                  error={
                                    checkErrorByField("quantity", index) ||
                                    isErrorQuantity(line.id)
                                  }
                                />
                              </MyTypography>
                              <MyTypography
                                variant={"body3"}
                                className={classes.ml10}
                              >
                                {line.salesUnit}
                              </MyTypography>
                            </div>
                            <span className={classes.txtError}>
                              {getErrorTextQuantity("quantity", index, line.id)}
                            </span>
                          </TableCell>
                          <TableCell
                            className={classes.noBorderRight}
                            align={"center"}
                          >
                            <MyTypography variant={"body3"}>
                              {isContainer(line) ? (
                                "-"
                              ) : (
                                <DecimalFormat
                                  value={line.weight || ""}
                                  isGrayDecimal={false}
                                  countDecimal={3}
                                />
                              )}
                            </MyTypography>
                          </TableCell>
                          <TableCell>
                            <SingleSelectField
                              showPlaceHolderWhenSelect
                              InputProps={{
                                classes: { input: classes.txtInputSelect }
                              }}
                              className={classes.selectField}
                              choices={[
                                {
                                  label: (
                                    <MyTypography variant={"subtitle3"}>
                                      TON
                                    </MyTypography>
                                  ),
                                  value:
                                    line.weightUnit === "ตัน" ? "ตัน" : "TON"
                                },
                                {
                                  label: (
                                    <MyTypography variant={"subtitle3"}>
                                      Kg.
                                    </MyTypography>
                                  ),
                                  value: "Kg."
                                }
                              ]}
                              onChange={e =>
                                handleChangeInput(e, line.id, "weightUnit")
                              }
                              placeholder={!isContainer(line) ? "Select" : ""}
                              value={
                                !isContainer(line)
                                  ? line.weightUnit ?? "TON"
                                  : ""
                              }
                              name={`weightUnit`}
                              id={`weightUnit-${line.id}`}
                              error={checkErrorByField("weightUnit", index)}
                              disabled={isContainer(line)}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleSelectField
                              allowBlank
                              InputProps={{
                                classes: { input: classes.txtInputSelect }
                              }}
                              className={classes.selectField}
                              choices={
                                isContainer(line)
                                  ? [
                                      {
                                        label: (
                                          <MyTypography variant={"subtitle3"}>
                                            ZKC0
                                          </MyTypography>
                                        ),
                                        value: "ZKC0"
                                      }
                                    ]
                                  : [
                                      {
                                        label: (
                                          <MyTypography variant={"subtitle3"} />
                                        ),
                                        value: ""
                                      },
                                      {
                                        label: (
                                          <MyTypography variant={"subtitle3"}>
                                            ZTNN
                                          </MyTypography>
                                        ),
                                        value: "ZTNN"
                                      },
                                      {
                                        label: (
                                          <MyTypography variant={"subtitle3"}>
                                            ZTN1
                                          </MyTypography>
                                        ),
                                        value: "ZTN1"
                                      }
                                    ]
                              }
                              onChange={e =>
                                handleChangeInput(e, line.id, "itemCatEo")
                              }
                              placeholder={"Select"}
                              value={line.itemCatEo || ""}
                              name={`itemCatEo`}
                              id={`itemCatEo-${line.id}`}
                              error={checkErrorByField("itemCatEo", index)}
                            />
                          </TableCell>
                          <TableCell align={"right"}>
                            {isContainer(line) ? (
                              ""
                            ) : (
                              <DecimalFormat
                                value={line?.piProduct?.pricePerUnit || ""}
                                isGrayDecimal={false}
                                countDecimal={2}
                              />
                            )}
                          </TableCell>
                          <TableCell>
                            <MyTypography variant={"body3"}>
                              {isContainer(line) ? "" : currency}
                            </MyTypography>
                          </TableCell>
                          <TableCell>
                            <SingleTextField
                              key={`plant[${index}${resetApplyPlant}]`}
                              regex={REGEX_ONLY_NUMBER_CHARACTER}
                              maxLengthProps={4}
                              value={formik.values.plant[index] || ""}
                              name={`plant[${index}]`}
                              id={`plant-${line.id}`}
                              className={classes.textFieldCustom}
                              onChange={e =>
                                handleChangeInput(e, line.id, "plant")
                              }
                              disabled={isContainer(line)}
                            />
                          </TableCell>
                          <TableCell>
                            <DatePicker
                              noBlock
                              key={`requestDate[${index}${resetApplyDate}]`}
                              value={line.requestDate || ""}
                              name={`requestDate[${index}]`}
                              id={`requestDate-${line.id}`}
                              onChange={e =>
                                handleChangeInput(e, line.id, "requestDate")
                              }
                              error={checkErrorByField("requestDate", index)}
                              helperText={
                                (formik.errors.requestDate &&
                                  formik.errors.requestDate[index]) ||
                                ""
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <span>
                              <SingleTextField
                                maxLengthProps={MAX_LENGTH_REF_PI}
                                value={line.refPiNo || ""}
                                name={"refPiNo"}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  handleChangeInput(e, line.id, "refPiNo")
                                }
                                disabled={isContainer(line)}
                                id={`refPiNo-${line.id}`}
                              />
                            </span>
                          </TableCell>
                          <TableCell>
                            <Button
                              className={classes.button}
                              variant="contained"
                              color="secondary"
                              onClick={() => handleInputParam(line)}
                              id={`edit-route-${line.id}`}
                            >
                              <SVG src={externalLinkIcon} />
                            </Button>
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell>
                            <SearchRoute
                              route={formik.values.route[index]}
                              setRoute={handleChangeRoute}
                              itemId={line.id}
                              contractNo={data?.pi?.code}
                            />
                          </TableCell>
                          <TableCell>
                            <MyTypography variant={"body3"}>
                              {formatConditionGroup(line)}
                            </MyTypography>
                          </TableCell>
                          <TableCell>
                            <MyTypography variant={"body3"}>
                              {line?.materialGroup2}
                            </MyTypography>
                          </TableCell>
                          <TableCell>
                            <MyTypography variant={"body3"} align={"center"}>
                              {line?.commissionPercent}
                            </MyTypography>
                          </TableCell>
                          <TableCell>
                            <MyTypography variant={"body3"} align={"center"}>
                              {line?.commissionAmount === null ? (
                                ""
                              ) : (
                                <DecimalFormat
                                  value={line?.commissionAmount}
                                  isGrayDecimal={false}
                                  countDecimal={2}
                                />
                              )}
                            </MyTypography>
                          </TableCell>
                          <TableCell>
                            <MyTypography variant={"body3"} align={"center"}>
                              {line?.commissionUnit}
                            </MyTypography>
                          </TableCell>
                          {!isK01K09(line) &&
                          !isContainer(line) &&
                          !isSpecialPlant(line) ? (
                            <>
                              <TableCell className={classes.noBorderRight}>
                                <MyTypography variant={"body3"}>
                                  <SingleTextFieldNoBlock
                                    key={`deliveryTolUnder[${index}${line.deliveryTolUnlimited}]`}
                                    name={`deliveryTolUnder[${index}]`}
                                    id={`deliveryTolUnder-${line.id}`}
                                    value={
                                      line.deliveryTolUnlimited
                                        ? 0
                                        : formik.values.deliveryTolUnder[index]
                                    }
                                    error={checkErrorByField(
                                      "deliveryTolUnder",
                                      index
                                    )}
                                    onChange={e =>
                                      handleChangeInput(
                                        e,
                                        line.id,
                                        "deliveryTolUnder"
                                      )
                                    }
                                    disabled={line.deliveryTolUnlimited}
                                    className={classNames(
                                      classes.textFieldCustom,
                                      {
                                        [classes.disabled]:
                                          line.deliveryTolUnlimited
                                      }
                                    )}
                                    regex={REGEX_ONLY_NUMBER}
                                    numberLimit={100}
                                  />
                                </MyTypography>
                              </TableCell>
                              <TableCell className={classes.noBorderRight}>
                                <MyTypography variant={"body3"}>
                                  <SingleTextFieldNoBlock
                                    key={`deliveryTolOver[${index}${line.deliveryTolUnlimited}]`}
                                    name={`deliveryTolOver[${index}]`}
                                    id={`deliveryTolOver-${line.id}`}
                                    value={
                                      line.deliveryTolUnlimited
                                        ? 0
                                        : formik.values.deliveryTolOver[index]
                                    }
                                    error={checkErrorByField(
                                      "deliveryTolOver",
                                      index
                                    )}
                                    onChange={e =>
                                      handleChangeInput(
                                        e,
                                        line.id,
                                        "deliveryTolOver"
                                      )
                                    }
                                    disabled={line.deliveryTolUnlimited}
                                    className={classNames(
                                      classes.textFieldCustom,
                                      {
                                        [classes.disabled]:
                                          line.deliveryTolUnlimited
                                      }
                                    )}
                                    regex={REGEX_ONLY_NUMBER}
                                    numberLimit={100}
                                  />
                                </MyTypography>
                              </TableCell>
                              <TableCell className={classes.unlimited}>
                                <span className={classes.delivery}>
                                  <Checkbox
                                    size={"small"}
                                    disabled={loadingDelivery}
                                    checked={line.deliveryTolUnlimited}
                                    name={`deliveryTolUnlimited[${index}]`}
                                    id={`deliveryTolUnlimited-${line.id}`}
                                    onChange={e =>
                                      handleClickCheckBox(
                                        e,
                                        line.id,
                                        "deliveryTolUnlimited",
                                        index
                                      )
                                    }
                                  />
                                  Unlimited
                                </span>
                              </TableCell>
                            </>
                          ) : haveNormalProduct ? (
                            <>
                              <TableCell className={classes.noBorderRight} />
                              <TableCell className={classes.noBorderRight} />
                              <TableCell className={classes.unlimited} />
                            </>
                          ) : (
                            ""
                          )}
                          <TableCell>
                            <SingleTextField
                              name={`rollDiameter[${index}]`}
                              id={`rollDiameter-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : formik.values.rollDiameter[index]
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                handleChangeInput(e, line.id, "rollDiameter")
                              }
                              error={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? false
                                  : checkErrorByField("rollDiameter", index)
                              }
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={10}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextField
                              name={`rollCoreDiameter[${index}]`}
                              id={`rollCoreDiameter-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : formik.values.rollCoreDiameter[index]
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                !(
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                ) &&
                                handleChangeInput(
                                  e,
                                  line.id,
                                  "rollCoreDiameter"
                                )
                              }
                              error={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? false
                                  : checkErrorByField("rollCoreDiameter", index)
                              }
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={10}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextField
                              name={`rollQuantity[${index}]`}
                              id={`rollQuantity-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : formik.values.rollQuantity[index]
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                !(
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                ) &&
                                handleChangeInput(e, line.id, "rollQuantity")
                              }
                              error={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? false
                                  : checkErrorByField("rollQuantity", index)
                              }
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={10}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextField
                              name={`rollPerPallet[${index}]`}
                              id={`rollPerPallet-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : formik.values.rollPerPallet[index]
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                !(
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                ) &&
                                handleChangeInput(e, line.id, "rollPerPallet")
                              }
                              error={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? false
                                  : checkErrorByField("rollPerPallet", index)
                              }
                              regex={REGEX_ONLY_NUMBER}
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={10}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextField
                              name={`palletSize[${index}]`}
                              id={`palletSize-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : formik.values.palletSize[index]
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                !(
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                ) && handleChangeInput(e, line.id, "palletSize")
                              }
                              error={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? false
                                  : checkErrorByField("palletSize", index)
                              }
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={10}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextFieldNoBlock
                              name={`palletNo[${index}]`}
                              id={`palletNo-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : line.palletNo
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                !(
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                ) && handleChangeInput(e, line.id, "palletNo")
                              }
                              error={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? false
                                  : checkErrorByField("palletNo", index)
                              }
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={10}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextFieldNoBlock
                              name={`packageQuantity[${index}]`}
                              id={`packageQuantity-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : line.packageQuantity
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                !(
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                ) &&
                                handleChangeInput(e, line.id, "packageQuantity")
                              }
                              error={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? false
                                  : checkErrorByField("packageQuantity", index)
                              }
                              regex={REGEX_ONLY_NUMBER}
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={10}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextField
                              name={`packingList[${index}]`}
                              id={`packingList-${line.id}`}
                              value={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                                  ? ""
                                  : line.packingList
                              }
                              className={classes.textFieldCustom}
                              onChange={e =>
                                !(
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                ) &&
                                handleChangeInput(e, line.id, "packingList")
                              }
                              disabled={
                                isK01K09(line) ||
                                isContainer(line) ||
                                isSpecialPlant(line)
                              }
                              maxLengthProps={132}
                            />
                          </TableCell>
                          <TableCell>
                            <SingleTextField
                              name={`shippingPoint[${index}]`}
                              id={`shippingPoint-${line.id}`}
                              value={formik.values.shippingPoint[index] || ""}
                              className={classes.textFieldCustom}
                              onChange={e =>
                                handleChangeInput(e, line.id, "shippingPoint")
                              }
                              error={checkErrorByField("shippingPoint", index)}
                              regex={REGEX_ONLY_NUMBER}
                              maxLengthProps={4}
                            />
                          </TableCell>
                          <TableCell>
                            <TextAreaField
                              value={line?.remark || ""}
                              name={"remark"}
                              id={`remark-${line.id}`}
                              className={classes.textFieldCustom}
                              onChange={e =>
                                handleChangeInput(e, line.id, "remark")
                              }
                              verticalResizingOnly
                              rowsMin={1}
                              maxLength={1320}
                              lineLimit={132}
                              rowsMax={10}
                            />
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={totalCols}>
                      <Skeleton />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {listMaterialCurrent && listMaterialCurrent.length ? (
              <StickyHorizontalScrollBar
                key={`scroll-${currentTab}`}
                container={containerRef}
                reRender={reRender}
                bottom={fullScreen ? 0 : 165}
              />
            ) : null}
          </div>
          <TablePaginationCustom
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
            totalCount={totalCount}
            selectColor="#007E92"
            settings={settings}
            onUpdateListSettings={onUpdateListSettings}
            isBackFistPage
            isNextLastPage
            latestPageItemNumber={latestPageItemNumber}
            onNextLastPage={onNextLastPage}
            onPreviousFirstPage={onPreviousFirstPage}
            disabled={disabled}
          />
        </>
      ) : null}
      {!listMaterial?.length ? <EmptyProduct hideTotal /> : null}
      <ModalInputParameter
        key={`ip_${componentKey}`}
        open={isOpenModalInputParameter}
        allowChangeInquiryMethod={true}
        initialValue={orderLine?.inquiryMethod}
        onClose={handleCloseModalInputParameter}
        onSave={handleSaveInputParameter}
      />
      <DialogProcessing
        open={loadingDelivery}
        description={"ระบบกำลังประมวลผล กรุณารอสักครู่"}
      />
    </>
  );
};

export default MaterialItemTab;
